<!-- layouts/MainLayout.vue -->
<template>
    <div class="main-layout">
        <!-- 顶部导航 -->
        <PageHeader />
        
        <!-- 主要内容区域 -->
        <main class="main-content">
            <router-view />
        </main>
        
        <!-- 底部导航 -->
    <PageFooter />
  </div>
</template>

<script setup>
import PageHeader from '@/components/header/PageHeader.vue';
import PageFooter from '@/components/footer/PageFooter.vue';
</script>

<style scoped>
.main-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
}
</style>